import * as React from "react";
import type { SVGProps } from "react";
const SvgCarFront = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#car-front_svg__a)">
      <path d="M20 19H4a1 1 0 0 1-.89-.55l-.79-1.58A3 3 0 0 1 2 15.53v-3.06a3 3 0 0 1 .32-1.34l.75-1.51 1.3-3.89A4 4 0 0 1 8.16 3h7.68a4 4 0 0 1 3.79 2.74l1.3 3.88.75 1.51a3 3 0 0 1 .32 1.34v3.06a3 3 0 0 1-.32 1.34l-.79 1.58A1 1 0 0 1 20 19M4.62 17h14.76l.51-1a1 1 0 0 0 .11-.45v-3.06a1 1 0 0 0-.11-.45l-.78-1.57a1 1 0 0 1-.06-.13l-1.32-4a2 2 0 0 0-1.89-1.37H8.16a2 2 0 0 0-1.89 1.37l-1.32 4a1 1 0 0 1-.06.13l-.78 1.57a1 1 0 0 0-.11.45v3.06a1 1 0 0 0 .11.45z" />
      <path d="M7.49 21h-2a1.52 1.52 0 0 1-1.51-1.51V18a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v1.49A1.52 1.52 0 0 1 7.49 21M18.49 21h-2a1.52 1.52 0 0 1-1.51-1.51V18a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v1.49A1.52 1.52 0 0 1 18.49 21M12.12 12H12a29.7 29.7 0 0 1-8.26-1 1 1 0 0 1-.71-1.23 1 1 0 0 1 1.23-.71 27.6 27.6 0 0 0 7.74 1h.11c2.579.042 5.15-.294 7.63-1a1 1 0 0 1 1.23.71 1 1 0 0 1-.71 1.23 28.4 28.4 0 0 1-8.14 1M7 15H6a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2M18 15h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2M12 16.25a9.4 9.4 0 0 1-2.24-.28 1 1 0 0 1 .48-1.94 7.2 7.2 0 0 0 3.52 0 1 1 0 0 1 1.095 1.486 1 1 0 0 1-.615.454 9.4 9.4 0 0 1-2.24.28" />
      <path d="M20 11a.93.93 0 0 1-.45-.11 1 1 0 0 1-.44-1.34l1-2a1 1 0 0 1 1.34-.44 1 1 0 0 1 .44 1.34l-1 2A1 1 0 0 1 20 11" />
      <path d="M23 9h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2M4 11a1 1 0 0 1-.89-.55l-1-2a1 1 0 0 1 .44-1.34 1 1 0 0 1 1.34.44l1 2a1 1 0 0 1-.44 1.34A.93.93 0 0 1 4 11" />
      <path d="M3 9H1a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2" />
    </g>
    <defs>
      <clipPath id="car-front_svg__a">
        <path fill="#fff" d="M0 3h24v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCarFront;
